const demo_app = {
    landing_title: 'Business app demo',
    landing_subtitle: 'This page represents a business application (Sat Alert / eLogbook / IUU). Sign in with your Sat-Alert IAM account to continue.',
    login_button: 'Sign in with Sat-Alert IAM',
    title: "You're signed in",
    subtitle: 'Signed in with the following account:',
    username: 'Username: ',
    user_id: 'User ID: ',
    sign_out: 'Sign out',
    continue_explore: 'Or continue to explore',
    customize_sign_in_experience: 'Customize sign-in experience',
    enable_passwordless: 'Enable passwordless',
    add_social_connector: 'Add social connector',
};
export default Object.freeze(demo_app);
